import { Injectable, OnDestroy } from "@angular/core";
import { BaseAccessPropertiesRequestClass } from "../models/general/base-access-properties-request.class";
import { Subscription } from "rxjs";
import { AuthenticationService } from "./authentication.service";
import { User } from "../models/user";
import { ExistsIn } from "../_helpers/ArrayExtensionMethodHelper.functions";
import { SessionStorageService } from "./session-storage.service";
import { RequestActionTypeEnum } from "../constants/request-action-type.enum";

/**
 * Service that can validate what actions the CURRENT USER is allowed to do on the given Request
 */
@Injectable({
    providedIn: 'root'
})
export class VerifyRequestActionService implements OnDestroy {

    private usersubscription: Subscription;
    private user!: User;


    constructor(private authenticationService: AuthenticationService, private sessionStorageService: SessionStorageService
    ) {
        this.usersubscription = this.authenticationService.currentUser.subscribe((userModel) => {
            this.user = userModel;
        });
    }
    /**
     * is the given request+Action ALLOWED for the CURRENT USER
     * @param request 
     * @param forAction 
     * @returns 
     */
    public IsAllowed(request: BaseAccessPropertiesRequestClass, forAction: RequestActionTypeEnum): boolean {
        if (!this.user || !request) {
            return false;
        }

        let isOwner = this.isOwner(request.ownerGuid);
        let inWorkGroup = this.isInWorkgroup(request.workgroupGuid);

        let showAllDocsInOrg = this.sessionStorageService.showAllRequestForOrganisation;

        switch (forAction) {
            case RequestActionTypeEnum.View:
                return true;
            case RequestActionTypeEnum.Delete:
            case RequestActionTypeEnum.ChangeWorkGroup:
                return isOwner;
            case RequestActionTypeEnum.Purge:
            case RequestActionTypeEnum.Withdraw:
            case RequestActionTypeEnum.EditDeadline:
            case RequestActionTypeEnum.SendReminder:
            case RequestActionTypeEnum.Restore:
            case RequestActionTypeEnum.Download:
            case RequestActionTypeEnum.ShowDocument:
            case RequestActionTypeEnum.Export:
            case RequestActionTypeEnum.EditSendGroup:
            case RequestActionTypeEnum.EditUserDetails:
            case RequestActionTypeEnum.TakeAPeekAtInvite:
            case RequestActionTypeEnum.ChangeSignatureProvider:
            case RequestActionTypeEnum.EditRequest:
            case RequestActionTypeEnum.EditFilingData:
                return isOwner || inWorkGroup;
            case RequestActionTypeEnum.BecomeOwner:
                return !isOwner && showAllDocsInOrg && this.user.isOrganisationAdmin;
            default:
                return false;
        }
    }

    ngOnDestroy() {
        if (this.usersubscription) { this.usersubscription.unsubscribe(); }
    }


    public isOwner(ownerGuid: string): boolean {
        // optional:
        //let user = this.authenticationService.currentUserValue;
        return ownerGuid === this.user.sub;
    }

    public isInWorkgroup(workgroupGuid: string | null | undefined): boolean {
        if (!workgroupGuid) return false;
        let workgroups = this.authenticationService.UserWorkgroups;
        return ExistsIn(workgroups, "guid", workgroupGuid);
    }


}